//获取卡状态
let stateArr = [
    {name:'正常', val:1, className:'color_theme'},
    {name:'停机', val:2, className:'color_stop'},
    {name:'沉默期', val:3, className:''},
    {name:'测试期', val:5, className:''},
    {name:'停机保号', val:6, className:''}
]

export default stateArr;


// WEBPACK FOOTER //
// ./src/assets/script/state.js